var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report_container full"},[(_vm.list_gridOptions)?_c('vxe-grid',_vm._b({on:{"toolbar-button-click":_vm.list_toolbarButtonClickEvent}},'vxe-grid',_vm.list_gridOptions,false)):_vm._e(),_c('list-index',{ref:"listIndex",attrs:{"knowledgetype":_vm.knowledgetype,"goodscode":_vm.goodscode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }